import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const RentPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.rentpackages.editPackage'}>
      <Edit>
        <BasePackageForm entity="rents" />
      </Edit>
    </SectionWrapper>
  )
}

export default RentPackageEdit
